export default __webpack_public_path__ + "static/media/chart.e54abfa1.svg";